<template>
  <div>
    <p
      class="mb-0 black2-color d-flex justify-space-between"
      :class="[labelClass ?? 'font-18 font-weight-medium main-label__wrapper']"
    >
      <span>
        <span class="letter-spacing-4 mr-1" v-html="text"></span
        ><v-tooltip
          top
          color="primary"
          content-class="tooltipTop primary"
          v-if="helpText && helpText.length"
          ><template v-slot:activator="{ on, attrs }"
            ><v-icon
              color="accent"
              class="tooltip text-decoration-none"
              v-on="on"
              v-bind="attrs"
              >mdi-help-circle</v-icon
            ></template
          ><span v-html="helpText"></span
        ></v-tooltip>
      </span>
      <slot name="actionLabel" v-if="actionBtnLabel">
        <BaseButton
          @click="$emit('click:actionBtn')"
          :text="actionBtnLabel"
          link
          flat
          dense
          small
        />
      </slot>
    </p>
    <p v-if="hintText" class="sub-help-text">
      {{ hintText }}
    </p>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseComponents/BaseButton";
export default {
  name: "BaseLabel",
  components: {
    BaseButton,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    helpText: String,
    hintText: String,
    labelClass: {
      type: String,
    },
    actionBtnLabel: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
i.tooltip.v-icon.v-icon {
  font-size: 18px !important;
  top: -2px !important;
  position: relative !important;
}

.sub-help-text {
  margin-top: 3px;
  margin-bottom: 13px;
  display: block;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: left;
  color: #272727;
  width: 584px;
}

.letter-spacing-4 {
  letter-spacing: 0.4px;
}

@media screen and (max-width: $grid-breakpoints-md) {
  .sub-help-text {
    width: 100%;
  }
}
</style>
